import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GridController, TSortDirections } from '../../classes/grid-page-info';
import {
  DropDownItem,
  FilterItems,
  type ISelect,
} from '../../components/filters/filter.interface';
import {
  IProviderDTO,
  ProviderFilters,
} from '../../interfaces/provider/provider.interfaces';
import { CommonGraphqlService } from '../common.graphql.service';

@Injectable({
  providedIn: 'root',
})
export class ProviderStateService extends GridController<ProviderFilters> {
  public defaultFilter: ProviderFilters = {
    id: '',
    groupId: '',
    accountNumber: '',
    groupName: '',
    pMS: '',
    contactName: '',
    accountName: '',
    phone: '',
    email: '',
    zipcode: '',
    city: '',
    state: '',
  };

  override _sortDirections: TSortDirections = {
    lastName: '',
    contactEmail: '',
    recordStatus: '',
    addressCity: '',
    id: 'ASC',
    providerGroupId: '',
    accountNumber: '',
  };

  filters: FilterItems = {
    filtersName: 'provider',
    items: [
      {
        caption: 'Provider ID',
        name: 'id',
        type: 'text',
        placeholder: 'Enter Provider ID',
      },

      {
        caption: 'Group ID',
        name: 'groupId',
        type: 'text',
        placeholder: 'Enter Group ID',
      },
      {
        caption: 'Group Name',
        name: 'groupName',
        type: 'text',
        placeholder: 'Enter Group Name',
      },
      {
        caption: 'Account Number',
        name: 'accountNumber',
        type: 'text',
        placeholder: 'Enter Account Number',
      },
      {
        caption: 'Account Name',
        name: 'accountName',
        type: 'text',
        placeholder: 'Enter Account Name',
      },
      {
        caption: 'Contact Name',
        name: 'contactName',
        type: 'text',
        placeholder: 'Enter Contact Name',
      },
      // {
      //   caption: "Phone",
      //   name:"phone",
      //   type:'text',
      //   placeholder: "Enter Phone",

      // },
      // {
      //   caption: "Email",
      //   name:"email",
      //   type:'text',
      //   placeholder: "Enter Email",

      // },
      // {
      //   caption: "Zip Code",
      //   name:"zipcode",
      //   type:'text',
      //   placeholder: "Enter Zip Code",

      // },
      {
        caption: 'City',
        name: 'city',
        type: 'text',
        placeholder: 'Enter City',
      },
      {
        caption: 'State',
        name: 'state',
        type: 'states',
      },
      {
        caption: 'Practice Management',
        name: 'pMS',
        type: 'select',
        placeholder: 'Select Application',
        asyncValues: undefined,
      },
    ],
  };

  private _providers: IProviderDTO[];

  constructor(private srvCommmon: CommonGraphqlService) {
    super();
    this.init(this.defaultFilter, 1, 'accountNumber', 'ASC');

    const pmsSoftwareFilter = this.filters.items?.find((f) => {
      return f.name === 'pMS';
    }) as ISelect;
    pmsSoftwareFilter.asyncValues = this.getApplications();
  }

  get providers(): IProviderDTO[] {
    return this._providers;
  }

  set providers(value: IProviderDTO[]) {
    this._providers = value;
  }

  // getStates():Observable<IState[]>{
  //   return this.srvCommmon.getStates();
  // }

  getApplications(): Observable<DropDownItem[]> {
    return this.srvCommmon.getApplications().pipe(
      map((apps) => {
        return apps.map((a) => {
          return { key: a.code, value: a.description };
        });
      }),
    );
  }
}
